/**
 * The colours a campaign can be, and the whole set of them.
 *
 * Fixed rather than free: a campaign colour lands next to pipeline state on the
 * same screen, so it has to stay inside the palette the rest of the UI speaks.
 * The red here is a brick, deliberately not `--stamp-red` — that token means QC
 * flag, and a chip edge in it would read as an alert.
 */
export const CAMPAIGN_COLORS: readonly { value: string; label: string }[] = [
  { value: '#3A5A78', label: 'Machine blue' },
  { value: '#4C7A54', label: 'Green' },
  { value: '#C98A2E', label: 'Amber' },
  { value: '#9E4B33', label: 'Brick' },
  { value: '#7A6A55', label: 'Kraft' },
  { value: '#4A4A46', label: 'Graphite' },
];

/** What a new campaign opens on. */
export const DEFAULT_CAMPAIGN_COLOR = CAMPAIGN_COLORS[0]?.value ?? '#3A5A78';
